<div *ngIf="horizontalMenu" class="navbar-header d-xl-block d-none"

>
  <!-- Navbar brand -->
  <ul class="nav navbar-nav flex-row">
    <li class="nav-item">
      <a class="navbar-brand" [routerLink]="['/']">
        <span class="brand-logo">
          <img src="{{ coreConfig.app.appLogoImage }}" alt="brand-logo" width="36" />
        </span>
        <h2 class="brand-text mb-0"> {{ 'MENU.DASHBOARD.MIRACLE' | translate }}  </h2>
      </a>
    </li>
  </ul>
  <!--/ Navbar brand -->
  
</div>



<div class="navbar-container dashboard-navbar-shell d-flex content">
  <div class="dashboard-navbar-welcome">
    {{ 'MENU.DASHBOARD.ADMIN_WELCOME' | translate }}
  </div>

  <div class="bookmark-wrapper d-flex align-items-center">
    <!-- Menu Toggler | Menu icon will be hidden in case of layout without menu -->
    <ul class="nav navbar-nav d-xl-none" *ngIf="!coreConfig.layout.menu.hidden">
      <li class="nav-item">
        <a class="nav-link menu-toggle" (click)="toggleSidebar('menu')">
          <span [data-feather]="'menu'" [class]="'ficon'"></span>
        </a>
      </li>
    </ul>
    <!--/ Menu Toggler -->

    <!-- Toggle skin -->
    <!-- <li class="nav-item d-none d-lg-block">
      <a type="button" class="nav-link nav-link-style btn" (click)="toggleDarkSkin()">
        <span [ngClass]="currentSkin === 'dark' ? 'icon-sun' : 'icon-moon'" class="ficon font-medium-5 feather"></span>
      </a>
    </li> -->
    <!--/ Toggle skin --> 
  </div>

  <ul class="nav navbar-nav align-items-center dashboard-navbar-actions">
    <!-- ? Language selection | Uncomment if needed -->
    <li ngbDropdown class="nav-item dropdown dropdown-language dashboard-language-item">
      <a class="nav-link dropdown-toggle dashboard-language-toggle" id="dropdown-flag" ngbDropdownToggle>
        <i class="flag-icon flag-icon-{{ languageOptions[_translateService.currentLang || currentLang || 'ar']?.flag }}"></i>
        <span class="selected-language">{{ languageOptions[_translateService.currentLang || currentLang || 'ar']?.title }}</span>
      </a>
      <div ngbDropdownMenu aria-labelledby="dropdown-flag">
        <!-- Use ng-container to separate ngFor and ngIf -->
       <ng-container *ngFor="let lang of _translateService.getLangs()">
  <a
    class="language-item"
    *ngIf="languageOptions[lang]"
    ngbDropdownItem
    (click)="setLanguage(lang)"
  >
    <i class="flag-icon" [ngClass]="'flag-icon-' + languageOptions[lang]?.flag"></i>
    <span style="width: 51px;">{{ languageOptions[lang]?.title }}</span>
  </a>
</ng-container>
      </div>
    </li>
    <!--/ Language selection -->

    <!-- User Dropdown -->
    <li ngbDropdown class="nav-item dropdown-user dashboard-user-item">
      <a
        class="nav-link dropdown-toggle dropdown-user-link"
        id="dropdown-user"
        ngbDropdownToggle
        id="navbarUserDropdown"
        aria-haspopup="true"
        aria-expanded="false"
      >
        <div class="user-nav d-flex">
          <span class="user-name">{{ displayUserName || ('MENU.DASHBOARD.user_name' | translate) }}</span>
          <span class="user-status">{{ displayUserEmail }}</span>
        </div>
        <span class="avatar"
          ><img
            class="round"
            [src]="displayUserImage"
            alt="avatar"
            height="40"
            width="40" style="background-color: white;"/>
            <span class="avatar-status-online"></span
        ></span>
      </a>
      <div ngbDropdownMenu aria-labelledby="navbarUserDropdown" class="dropdown-menu dropdown-menu-right">
        <!-- <a ngbDropdownItem [routerLink]="['/']"><span [data-feather]="'user'" [class]="'mr-50'"></span> Profile</a
        ><a ngbDropdownItem [routerLink]="['/']"><span [data-feather]="'mail'" [class]="'mr-50'"></span> Inbox</a
        ><a ngbDropdownItem [routerLink]="['/']"><span [data-feather]="'check-square'" [class]="'mr-50'"></span> Task</a
        ><a ngbDropdownItem [routerLink]="['/']"
          ><span [data-feather]="'message-square'" [class]="'mr-50'"></span> Chats</a
        > -->
        <!-- <div class="dropdown-divider"></div> -->
        <a ngbDropdownItem href="#" (click)="$event.preventDefault(); logout()"

          ><span [data-feather]="'power'" [class]="'mr-50'"></span> {{ 'MENU.DASHBOARD.logout' | translate }}</a
        >
      </div>
    </li>

    <li class="nav-item dashboard-logout-item">
      <button type="button" class="dashboard-logout-button" (click)="logout()">
        <span [data-feather]="'log-out'" class="dashboard-action-icon"></span>
        <span>{{ 'MENU.DASHBOARD.logout' | translate }}</span>
      </button>
    </li>
    <!--/ User Dropdown -->

 
        <!-- Menu Toggler | Menu icon will be hidden in case of layout without menu -->
        <!-- <ul class="nav navbar-nav d-xl-none" *ngIf="!coreConfig.layout.menu.hidden">
          <li class="nav-item">
            <a class="nav-link menu-toggle" (click)="toggleSidebar('menu')">
              <span [data-feather]="'menu'" [class]="'ficon'"></span>
            </a>
          </li>
        </ul> -->


        <!-- not apear in reponsive   -->
        <!--/ Menu Toggler -->
    
        <!-- Add Sign-In Button -->
        <!-- <li class="nav-item">
          <a class="btn btn-primary nav-link" [routerLink]="['/sin-in']">
            <span [data-feather]="'log-in'" class="mr-50"></span> Sign In
          </a>
        </li> -->
      
  </ul>
</div>
